export const routes = {
  jobs: "/api/jobs",
  jobDetails: "/api/jobs/:id",
  talentBank: "/api/talent-banks",
  upload: "/api/upload",
};

export const baseUrl = "https://cms.pruebagpd.com";
